/**
 * Pure validators for the MOS/AOC profile resource.
 *
 * Split out from mos-profiles.tsx so unit tests can import them without
 * pulling in react-admin (which has ESM resolution quirks in vitest).
 */

// KSB taxonomy tag format: <domain>-<code>, e.g. 'S-PHYS', 'K-TCCC', 'B-LEAD'
export const TAG_PATTERN = /^[KSB](-[A-Z0-9_-]+)?$/;

export interface Requirement {
  tag: string;
  minPct: number;
}

/**
 * Validate a single {tag, minPct} requirement. Returns null on OK, a human
 * message on failure. Mirrors the chamber-v2 server-side validator so admin
 * UX errors match backend rejections.
 */
export function validateRequirement(req: unknown): string | null {
  if (!req || typeof req !== 'object') return 'requirement must be an object';
  const { tag, minPct } = req as { tag?: unknown; minPct?: unknown };
  if (typeof tag !== 'string' || !TAG_PATTERN.test(tag)) {
    return 'tag must match K-*, S-*, or B-*';
  }
  if (typeof minPct !== 'number' || !Number.isFinite(minPct) || minPct < 0 || minPct > 100) {
    return 'minPct must be a number in [0, 100]';
  }
  return null;
}
